// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
  companyStep: path(ROOTS_AUTH, '/company-step'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: (id) => `/${id}/payment`,
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  invite: (id) => `/invite/${id}`,
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    dashboard: path(ROOTS_DASHBOARD, '/dashboard'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
  },
  banking: path(ROOTS_DASHBOARD, '/banking'),
  dashboard: {
    root: path(ROOTS_DASHBOARD, '/dashboard'),
    sales: path(ROOTS_DASHBOARD, '/dashboard/sales'),
    performance: path(ROOTS_DASHBOARD, '/dashboard/performance'),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },

  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  fileManager: {
    root: path(ROOTS_DASHBOARD, '/files-manager'),
    adsera: path(ROOTS_DASHBOARD, '/files-manager/storage'),
    drive: path(ROOTS_DASHBOARD, '/files-manager/drive'),
    folder: (id) => path(ROOTS_DASHBOARD, `/files-manager/drive/${id}`),
    folderStore: (id) => path(ROOTS_DASHBOARD, `/files-manager/storage/${id}`),

  },
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  lead: {
    root: path(ROOTS_DASHBOARD, '/lead'),
    new: path(ROOTS_DASHBOARD, '/lead/new'),
    list: path(ROOTS_DASHBOARD, '/lead/list'),
    customers: path(ROOTS_DASHBOARD, '/lead/customers'),
    cards: path(ROOTS_DASHBOARD, '/lead/cards'),
    profile: (id) => path(ROOTS_DASHBOARD, `/lead/${id}/profile`),
    account: path(ROOTS_DASHBOARD, '/lead/account'),
    edit: (id) => path(ROOTS_DASHBOARD, `/lead/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/lead/reece-chung/edit`),
    ticket: path(ROOTS_DASHBOARD, '/lead/ticket'),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/products'),
    list: path(ROOTS_DASHBOARD, '/products/list'),
    new: path(ROOTS_DASHBOARD, '/products/new'),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    list: path(ROOTS_DASHBOARD, '/invoice/list'),
    new: path(ROOTS_DASHBOARD, '/invoice/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
    demoView: path(ROOTS_DASHBOARD, '/invoice/6322fdabd6ecf9bee8018a89'),
  },
  accounts: {
    root: path(ROOTS_DASHBOARD, '/accounts'),
    expense: path(ROOTS_DASHBOARD, '/accounts/expense'),
    list: path(ROOTS_DASHBOARD, '/accounts/list'),
    new: path(ROOTS_DASHBOARD, '/accounts/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/accounts/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/accounts/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/accounts/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
    demoView: path(ROOTS_DASHBOARD, '/accounts/6322fdabd6ecf9bee8018a89'),
  },

  orders: {
    root: path(ROOTS_DASHBOARD, '/orders'),
    list: path(ROOTS_DASHBOARD, '/orders/list'),
    new: path(ROOTS_DASHBOARD, '/orders/new'),
    expired: path(ROOTS_DASHBOARD, '/orders/expired'),
    expiredAll: path(ROOTS_DASHBOARD, '/orders/expired/all'),
    view: (id) => path(ROOTS_DASHBOARD, `/orders/${id}/view`),

    edit: (id) => path(ROOTS_DASHBOARD, `/orders/${id}/edit`),
    create: (LeadId) => path(ROOTS_DASHBOARD, `/orders/${LeadId}/new`),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: (title) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  },
  Companysetting: path(ROOTS_DASHBOARD, '/company-setting'),
};

export const PATH_DOCS = '';
